import UploadEmployeeCertificate from './UploadEmployeeCertificate.js';

export default UploadEmployeeCertificate;